import { Link, useIntl } from 'gatsby-plugin-intl'
import React from 'react'
import Layout from '../../components/Layout/index'
import PressRelease from '../../components/PressRelease'
import SEO from '../../components/seo'
import Footer from '../../modules/Footer'
import Header from '../../modules/Header'

import Image from '../../images/news/travelsandbox-from-freshcells-as-driver-for-hlx-touristik-business-model.jpg'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import messages from '../../messages/pageTitles.lang'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleNewsIberostar)}
        imageAlt={newsList.iberostar.imgAlt}
        description={formatMessage(metaDescription.NewsIberostarDescription)}
        image={Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.iberostar}
        articleLinks={{
          tsbo: <Link to="/products/travelsandbox/">travelsandbox®</Link>
        }}
        pageImgNoteLinks={{
          tsbo: <Link to="/products/travelsandbox/">TravelSandbox®</Link>,
          quickstart: <Link to="/products/quickstart/">QuickStart</Link>
        }}
      />
    </Layout>
  )
}

export default IndexPage
